function Page404() {
    return (
        <div className="page-center">
            <h1 style={{ color: "#fff" }}>Page 404</h1>
        </div>
    );
}

export default Page404;